import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, coalesce } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectQueryProps, SelectQueryViewProps, SelectQueryViewPropsRx } from "kea-react/dist/selector/query";

function mapSelectItem(x: models.ItemCatalogoSat): kea.SelectorElement {
    return {
        //TODO: Cuando se eliminen todos los demas catálogos del sat solo debe de quedar el ID registro
        value: coalesce(x.IdRegistro, x.Clave),
        label: x.Clave + " - " + x.Descripcion,
        view:
            <span>
                <span style={{ fontFamily: "monospace" }}>{x.Clave}</span>
                {" - "}
                <span style={{ fontStyle: "italic" }}>
                    {x.Descripcion}
                </span>
            </span>
    }
}

function queryClaveProducto(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveProductosSat, filtro);
}

export class ClaveProductoSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClaveProducto, resources.CatalogosSAT.GetProducto, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave producto SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesUsoCFDI(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveUsoCfdiSat, filtro);
}

export class ClaveUsoCFDISat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesUsoCFDI, resources.CatalogosSAT.GetUsoCfdi, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Uso CFDI SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesRegimenFiscal(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveRegimenFiscalSat, filtro);
}

export class ClaveRegimenFiscalSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesRegimenFiscal, resources.CatalogosSAT.GetRegimenFiscal, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Regimen fiscal SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesMonedaSat(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveMonedaSat, filtro);
}

export class ClaveMonedaSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesMonedaSat, resources.CatalogosSAT.GetMoneda, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Moneda SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesMetodoPagoSat(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveMetodoPagoSat, filtro);
}

export class ClaveMetodoPagoSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesMetodoPagoSat, resources.CatalogosSAT.GetMetodoPago, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Metodo pago SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesPaisSat(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClavePaisSat, filtro);
}
export class ClavePaisSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesPaisSat, resources.CatalogosSAT.GetPaisSat, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="País SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}

function queryClavesFormaPagoSat(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveFormaPagoSat, filtro);
}

export class ClaveFormaPagoSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesFormaPagoSat, resources.CatalogosSAT.GetFormaPago, mapSelectItem);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Forma pago SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}


function mapUnidad(x: models.UnidadSAT): kea.SelectorElement {
    return {
        value: x.IdRegistro,
        label: x.Descripcion
    }
}

function queryClavesUnidadSat(filtro: string) {
    return observeResource(resources.CatalogosSAT.ClaveUnidadSat, filtro);
}

export class ClaveUnidadSat extends React.PureComponent<SelectQueryViewPropsRx> {
    modalManager = kea.createModalManager();
    loadItems = kea.loadSelectorItemsFuncFromResource(queryClavesUnidadSat, resources.CatalogosSAT.GetUnidad, mapUnidad);

    render() {
        return (
            <div>
                <kea.SelectQuery label="Clave Unidad SAT" loadItems={this.loadItems} {... this.props} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/sat.tsx